import React, { useState, useEffect } from 'react';
import { HVAConversationProvider } from './FineTuningPlayground/HVAFineTuningPlaygroundContext';
import HVADynamicConversationWidget from './FineTuningPlayground/HVAFineTuningPlaygroundWidget';
import { useHVAConversation } from './FineTuningPlayground/HVAFineTuningPlaygroundContext';
import { Row, Col, Form } from 'react-bootstrap';
import fondo from 'assets/img/spot-illustrations/fondoaurea.png';
import aurealogo from 'assets/img/icons/logo2aurea.png';

// Configuración fija del agente
const AGENT_ID = 'agent_1759495911541_aaprmj6';
const CAMPAIGN_ID = -1; // Modo test
const CALL_TYPE = 'Inbound';

const AureaHVAAgentContent: React.FC = () => {
  // Hook del contexto
  const { conversationResults: contextConversationResults, setClientInfo } =
    useHVAConversation();

  // Estados
  const [conversationResults, setConversationResults] = useState('');

  // Datos iniciales del cliente (llamada entrante)
  useEffect(() => {
    setClientInfo({
      importid: '1',
      recordid: '1',
      companyname: 'Aurea Company',
      customername: 'Inbound Customer',
      customerphone: '+34600000000',
      customertrn: '00000000X',
      callcontext: {},
      bxpcontext: {}
    });
  }, [setClientInfo]);

  // Sincronizar desde el contexto hacia el estado local
  useEffect(() => {
    setConversationResults(contextConversationResults || '');
  }, [contextConversationResults]);

  // Función vacía para feedback (no se muestra pero el widget la necesita)
  const handleFeedback = () => {
    // No hacer nada - feedback oculto
  };

  // Función para manejar errores
  const handleComponentError = (error: Error) => {
    console.error('Error:', error.message);
  };

  return (
    <div
      className="p-2 px-4"
      style={{
        backgroundImage: `url(${fondo})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
        width: '100%'
      }}
    >
      {/* Header simple */}
      <Row className="mb-2 mt-8 align-items-center px-12 pe-0">
        <Col className="pt-0 d-flex align-items-center justify-content-center">
          <img src={aurealogo} alt="Aurea Logo" height={90} />
        </Col>
      </Row>
      <Row className="mb-4 align-items-center px-12 pe-0">
        <Col className="mb-4 pt-2 d-flex align-items-center justify-content-center">
          <h1 className="mb-1 text-white">
            El agente de IA que acompaña a las familias
          </h1>
        </Col>
      </Row>

      {/* Playground */}
      <Row className="pt-12 d-flex align-items-center justify-content-center px-12 pe-0">
        <Col xs={6} className="px-6">
          <HVADynamicConversationWidget
            agentId={AGENT_ID}
            agentImage={undefined}
            campaignId={CAMPAIGN_ID}
            callType={CALL_TYPE}
            onError={handleComponentError}
            onFeedback={handleFeedback}
            widgetHeight="280px"
          />
          {/* Resultados de la conversación */}
          <div className="mt-2">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h6 className="mb-0 text-white">Resumen de la conversación</h6>
            </div>
            <Form.Control
              as="textarea"
              rows={5}
              value={conversationResults}
              readOnly
              placeholder="Results will appear here after the call"
              className="scrollbar bg-body shadow-none"
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col className="pt-8 d-flex align-items-center justify-content-center px-12 pe-0">
          <p className="d-flex align-items-center justify-content-center fs-9 text-muted">
            Humanized Virtual Agents Management System|2025 © Zanna VirtualMind
            Solutions
          </p>
        </Col>
      </Row>
    </div>
  );
};

// Componente principal que provee el contexto
const AureaHVAAgent: React.FC = () => {
  return (
    <HVAConversationProvider>
      <AureaHVAAgentContent />
    </HVAConversationProvider>
  );
};

export default AureaHVAAgent;
